import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterLines = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 2.8235) scale(1.4118)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.4706 4.73547H1M16 1.20605H1M16 8.26488H1M12.4706 11.7943H1",
			stroke: "currentColor",
			strokeWidth: .8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgFilterLines);
export default ForwardRef;
